export default {
  namespaced: true,

  state: {
    userHasFirstInteracted: false,
  },

  mutations: {
    setUserHasFirstInteracted(state, value) {
      state.userHasFirstInteracted = value;
    },
  },
}
